import { render, staticRenderFns } from "./homeAppliances.vue?vue&type=template&id=044f775c&scoped=true"
import script from "./homeAppliances.vue?vue&type=script&lang=js"
export * from "./homeAppliances.vue?vue&type=script&lang=js"
import style0 from "./homeAppliances.vue?vue&type=style&index=0&id=044f775c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044f775c",
  null
  
)

export default component.exports